import React, { useState, useEffect, useContext, useRef } from 'react';
import axiosConfig from '../../../../utils/axiosConfig';
import { Formik, Form, Field } from 'formik';
import { fieldToTextField, TextField, TextFieldProps, Switch } from 'formik-material-ui';
import {
    Box, Button, Dialog, DialogActions,
    DialogContent, DialogContentText, DialogTitle,
    FormHelperText, Grid, List, ListItem, ListItemText,
    MenuItem, Slide, Typography, FormControl, InputLabel, Select
} from '@material-ui/core';

import { StateContext, DispatchContext } from '../../../../context/Provider';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ModalForm = (props) => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { globalState, facultyState, authState } = appState;
    const { globalDispatch, facultyDispatch } = appDispatch;

    let classroomInitialValue = {
        name: '',
        section: '',
        subject: '',
        room: '',
        theme_color: ''
    }

    if (authState.user.rol_id === 3) {
        classroomInitialValue.faculty = null;
    }

    const [classroom, setClassroom] = useState(classroomInitialValue);

    const [themeColor, setThemeColor] = useState('#2091EA')

    const [facultyUsers, setFacultyUsers] = useState([])

    async function createClassroom(values, resetForm) {

        const res = await axiosConfig.post(`/classrooms`, {
            name: values.name,
            section: values.section,
            subject: values.subject,
            room: values.room,
            theme_color: themeColor,
            faculty: values.faculty
        });

        if (res.data.status_code == 'ok') {
            console.log(res.data);
            globalDispatch({type: 'setSnackbarMsg', value: 'Class created successfully.'});
            globalDispatch({type: 'setIsOpenSnackbar', value: true});
            props.handleClose();
            props.fetchClassrooms();
        } else {
            console.log(res);
        }

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);
    }

    async function updateClassroom(values, resetForm) {

        const res = await axiosConfig.post(`/classrooms/${props.classID}`, {
            _method: 'PATCH',
            name: values.name,
            section: values.section,
            subject: values.subject,
            room: values.room,
            theme_color: themeColor
        });

        if (res.data.status_code == 'ok') {
            console.log(res.data);
            globalDispatch({type: 'setSnackbarMsg', value: 'Class updated successfully.'});
            globalDispatch({type: 'setIsOpenSnackbar', value: true});
            props.fetchClassrooms();
            props.handleClose();
        } else {
            console.log(res);
        }

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);
    }

    const getFacultyUsers = () => {
        axiosConfig.get(`/faculty`)
            .then(response => {
                let responseData = response.data
                if (!responseData.success) {
                    console.log(response.errors)
                }

                setFacultyUsers(responseData.users)
            })
    }

    useEffect(() => {

        if (authState.user.role_id === 3) {
            getFacultyUsers()
        }

        if (props.classID && props.classroom) {
            setClassroom(props.classroom);
            setThemeColor(props.classroom.theme_color)
        }

    }, [props.classID]);

    return (
        <>
            <Dialog
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="form-dialog-title"
                fullWidth={true}
                maxWidth={'sm'}
                TransitionComponent={Transition}
                disableBackdropClick
            >
                <Formik
                    initialValues={classroom}
                    validate={(values) => {
                        const errors = {};
                        if (!values.name) {
                            errors.name = 'This field is required';
                        }

                        if (!values.section) {
                            errors.section = 'This field is required';
                        }

                        if (!values.subject) {
                            errors.subject = 'This field is required';
                        }

                        if (!values.room) {
                            errors.room = 'This field is required';
                        }

                        return errors;
                    }}
                    onSubmit={(values, {setSubmitting, resetForm}) => {

                        setSubmitting(false);
                        globalDispatch({type: 'setIsLoading', value: true});

                        if (props.classID === null) {
                            createClassroom(values, resetForm);
                        } else {
                            updateClassroom(values, resetForm);
                        }

                        // setTimeout(() => {
                        //     setSubmitting(false);
                        //     alert(JSON.stringify(values, null, 2));
                        //     resetForm();
                        // }, 500);
                    }}
                >
                    {({submitForm, isSubmitting, touched, errors}) => (
                        <Form>
                            <DialogTitle id="form-dialog-title">
                                {props.dialogTitle}
                            </DialogTitle>
                            <DialogContent>
                                <Grid container alignItems="flex-start" spacing={2}>
                                    {authState.user.role_id === 3 && <Grid item xs={12}>
                                        <Field name="faculty">
                                            {({ field, form }) => (
                                                <FormControl fullWidth>
                                                    <InputLabel id="faculty-select">Assigned to Faculty</InputLabel>
                                                    <Select
                                                        {...field}
                                                        label="My Dropdown Select"
                                                        variant="outlined"
                                                        fullWidth
                                                    >
                                                        {facultyUsers.length > 0 && facultyUsers.map((user) => (
                                                            <MenuItem value={user.id}>{user.name}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            )}
                                        </Field>
                                    </Grid>}
                                    <Grid item xs={12}>
                                        <Field
                                            component={TextField}
                                            label="Class name (required)"
                                            name="name"
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            component={TextField}
                                            label="Section"
                                            name="section"
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            component={TextField}
                                            label="Subject"
                                            name="subject"
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            component={TextField}
                                            label="Room"
                                            name="room"
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>
                                    {/* <Grid item xs={12}>
                                        <Field
                                            error={errors.theme_color && true}
                                            component={Select}
                                            // type="text"
                                            name="theme_color"
                                            multiple={false}
                                            inputProps={{name: 'theme_color', id: 'theme_color'}}
                                            fullWidth
                                            variant="outlined"
                                            displayEmpty
                                        >
                                            <MenuItem value={``}>-Select Theme Color-</MenuItem>
                                            <MenuItem value={`#ff5722`}>Orange</MenuItem>
                                            <MenuItem value={`#2091EA`}>Blue</MenuItem>
                                            <MenuItem value={`#49A94D`}>Green</MenuItem>
                                        </Field>

                                        {
                                            errors.theme_color && (
                                                <Box px={1.5}>
                                                    <FormHelperText error={true}>
                                                        {errors.theme_color}
                                                    </FormHelperText>
                                                </Box>
                                            )
                                        }
                                    </Grid> */}
                                    <Grid item xs={12}>
                                        <label htmlFor="themeColor" style={{fontSize: '11px', color: '#585858'}}>Theme Color:</label>
                                        <input
                                            // ref={themeColor}
                                            type="color"
                                            value={themeColor}
                                            style={{width: '100%', border: 'none', height: '50px', padding: '5px'}}
                                            onChange={(input) => {
                                                setThemeColor(input.target.value)
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={props.handleClose}
                                    disabled={isSubmitting}
                                    color="secondary"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    disabled={isSubmitting}
                                    onClick={submitForm} color="primary"
                                >
                                    Submit
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    );
}

export default ModalForm;